import { useState } from "react";
import { useGetCocktailsQuery } from "../../../../services/cocktail";
import { useGetGlassTypesQuery } from "../../../../services/glassTypes";
import { ModalButton } from "../../../Controls/Buttons/ModalButton";
import { StyledIonCheckbox } from "../../../Controls/Inputs/CheckboxSelect";
import Input from "../../../Controls/Inputs/Input";
import Loader from "../../../Controls/Loader/Loader";
import { QuizButtonsWrapper } from "../../../Quizzes/Quiz/QuizButtonsWrapper";
import { NotFoundText } from "../CocktailsFiltersModal";
import { Magnifier } from "../../../Icons/Magnifier";
import { useCocktailsContext } from "../../../../hooks/useAppContext";

interface GlassTypeProps {
    choicesCocktails: number[];
    setOpenModal: (isOpen: boolean) => void;
}

const GlassType = (props: GlassTypeProps) => {
    const { setOpenModal, choicesCocktails } = props;
    const [searchGlassTypeValue, setSearchGlassTypeValue] = useState("");
    const [choiceCocktails, setChoiceCocktails] =
        useState<number[]>(choicesCocktails);
    const { dispatch, state } = useCocktailsContext();

    const {
        data: glassTypeData,
        isFetching,
        isSuccess,
    } = useGetGlassTypesQuery({
        search: searchGlassTypeValue,
        per_page: 50,
    });

    const { data: cocktailsData, isFetching: fetchingData } =
        useGetCocktailsQuery({
            search: state.search,
            glass_type_ids:
                choiceCocktails.length > 0 ? choiceCocktails : undefined,
            per_page: 50,
        });

    const handleShowResult = () => {
        dispatch({
            type: "FILTER_BY_GLASS_TYPE",
            payload: choiceCocktails,
        });
        setOpenModal(false);
    };

    const handleCheckCategory = (id: number) => {
        setChoiceCocktails((choiceCocktails) => {
            if (choiceCocktails.includes(id)) {
                return choiceCocktails.filter((cocktail) => cocktail !== id);
            } else {
                return [...choiceCocktails, id];
            }
        });
    };

    return (
        <>
            <Input
                icon={<Magnifier height={25} />}
                type="text"
                value={searchGlassTypeValue}
                placeholder="Znajdź typ szklanki"
                onChange={(value) => setSearchGlassTypeValue(value)}
                marginBottom={16}
            />
            {isFetching ? (
                <Loader fullScreen />
            ) : isSuccess ? (
                glassTypeData?.data.map((glassType) => (
                    <StyledIonCheckbox
                        key={glassType.id}
                        onIonChange={() => handleCheckCategory(glassType.id)}
                        labelPlacement="end"
                        checked={choiceCocktails.some(
                            (item) => item === glassType.id
                        )}
                    >
                        {glassType.name}
                    </StyledIonCheckbox>
                ))
            ) : null}
            {glassTypeData?.data.length === 0 && (
                <NotFoundText>{`Nie znaleziono typu szklanki o nazwie ${searchGlassTypeValue}`}</NotFoundText>
            )}

            <QuizButtonsWrapper>
                <ModalButton
                    color={"white"}
                    onClick={() => setChoiceCocktails([])}
                >
                    wyczyść
                </ModalButton>
                <ModalButton
                    disabled={fetchingData || !cocktailsData?.meta.total}
                    onClick={handleShowResult}
                >
                    {fetchingData ? (
                        <Loader />
                    ) : (
                        `wyświetl (${cocktailsData?.meta.total ?? "0"})`
                    )}
                </ModalButton>
            </QuizButtonsWrapper>
        </>
    );
};

export default GlassType;
